import classnames from 'classnames'

import Button from '@components/Button'
import Checkbox from '@components/Checkbox'
import FormsyInput from '@components/Textfield/withFormsy'
import Select from '@components/Select/RequiredSelectWithFormsy'

import { withTranslate } from '@i18n/utils'

import {
    ADDRESS_TYPE_BILLING,
    ADDRESS_TYPE_SHIPPING,
    SUBSCRIPTION_CREDENTIAL_TYPE_MAIL,
    SUBSCRIPTION_CREDENTIAL_TYPE_EXPMAIL,
} from 'dashboard-subscriptions/constants'
import { paymentMethodOptionLabel } from 'dashboard-subscriptions/utils'
import AddressForm from 'dashboard-subscriptions/components/BillingTab/AddressForm'

import styles from 'dashboard-subscriptions/components/styles.module.scss'

const BillingTabForm = ({
    billing,
    cards,
    paymentMethod,
    translate: t,
    shipping,
    shippingSameAsBilling,
    setShippingSameAsBilling,
    fieldsDisabled,
    showPadModal,
    subscription,
    onChangeBillingData,
}) => {
    const isShippingAddressVisible =
        subscription.extended.fieldMap.credentialDistribution?.value === SUBSCRIPTION_CREDENTIAL_TYPE_MAIL ||
        subscription.extended.fieldMap.credentialDistribution?.value === SUBSCRIPTION_CREDENTIAL_TYPE_EXPMAIL

    return (
        <div>
            <div className="d-md-flex row">
                <div className="col-md-4">
                    <span className={classnames('mb-3', styles.columnLabel)}>
                        <T>dashboard.subscriptions.modal.label.bill.to</T>
                    </span>
                    <div className="mb-3">
                        <FormsyInput
                            value={billing.firstName}
                            name="billing.firstName"
                            required
                            placeholder={t('dashboard.account.firstName')}
                            validationError={t('dashboard.account.firstName.invalid')}
                            disabled={fieldsDisabled}
                        />
                    </div>
                    <div className="mb-3">
                        <FormsyInput
                            value={billing.lastName}
                            name="billing.lastName"
                            required
                            placeholder={t('dashboard.account.lastName')}
                            validationError={t('dashboard.account.lastName.invalid')}
                            disabled={fieldsDisabled}
                        />
                    </div>
                    <Select
                        options={cards}
                        onChange={onChangeBillingData}
                        isSearchable
                        getSelectValue={value => cards.find(c => c.id === value)}
                        getOptionLabel={paymentMethodOptionLabel}
                        getOptionValue={option => option.id}
                        name="billingCreditCard"
                        placeholder={t('dashboard.label.card')}
                        value={paymentMethod?.id}
                        required
                    />
                    <Button
                        onClick={showPadModal}
                        size="small"
                        btnStyle="outline"
                        type="button"
                        disabled={fieldsDisabled}
                        className={classnames('mt-3', 'mb-3', styles.preAuth)}>
                        <T>dashboard.subscriptions.billing.preauth.debit</T>
                    </Button>
                </div>
                <div className={classnames('col-md-4', 'text-left', { ['col-md-8']: shippingSameAsBilling })}>
                    <span className={classnames('mb-3', styles.columnLabel)}>
                        <T>dashboard.subscriptions.modal.label.billing.address</T>
                    </span>
                    <AddressForm
                        type={ADDRESS_TYPE_BILLING}
                        data={billing}
                        prefix="billing"
                        fieldsDisabled={fieldsDisabled}
                    />
                    {isShippingAddressVisible && (
                        <Checkbox
                            className={classnames('mt-3', styles.checkboxWithLabel)}
                            checked={shippingSameAsBilling}
                            disabled={fieldsDisabled}
                            onClick={() => setShippingSameAsBilling(!shippingSameAsBilling)}>
                            <T>dashboard.subscriptions.billing.same.address</T>
                        </Checkbox>
                    )}
                </div>
                {!shippingSameAsBilling && (
                    <div className="col-md-4">
                        <span className={classnames('mb-3', styles.columnLabel)}>
                            <T>dashboard.subscriptions.modal.label.shipping.address</T>
                        </span>
                        <AddressForm
                            type={ADDRESS_TYPE_SHIPPING}
                            data={shipping}
                            prefix="shipping"
                            fieldsDisabled={fieldsDisabled}
                        />
                    </div>
                )}
            </div>
        </div>
    )
}

export default compose(withTranslate)(BillingTabForm)
